import { h } from "../core/dom.js";
import { parseDate } from "../lib/format.js";

// GitHub-style training consistency grid: one column per week (Mon-anchored, to match
// the Monday-based weekly streak), 7 day-rows, colour-graded by sessions that day.
// Computes from a sessions list already in hand — no extra request.
export function trainingHeatmap(sessions, { weeks = 18 } = {}) {
  const counts = new Map();
  for (const s of sessions || []) {
    const d = parseDate(s.started_at);
    if (!d) continue;
    const k = dayKey(d);
    counts.set(k, (counts.get(k) || 0) + 1);
  }

  const today = startOfDay(new Date());
  const monday = startOfDay(new Date());
  monday.setDate(monday.getDate() - ((monday.getDay() + 6) % 7)); // back up to this week's Monday
  const start = new Date(monday);
  start.setDate(start.getDate() - (weeks - 1) * 7);

  const cols = [];
  for (let w = 0; w < weeks; w++) {
    const cells = [];
    for (let row = 0; row < 7; row++) {
      const day = new Date(start);
      day.setDate(start.getDate() + w * 7 + row);
      const future = day > today;
      const c = future ? 0 : counts.get(dayKey(day)) || 0;
      // Binary: a single workout fully lights the day (multiple/day is rare and not
      // worth a gradient that makes the common case look weak).
      cells.push(h("div", {
        class: ["hm-cell", future ? "hm-future" : c > 0 ? "hm-on" : "hm-off"],
        title: future ? "" : `${day.toLocaleDateString(undefined, { month: "short", day: "numeric" })} · ${c ? "trained" + (c > 1 ? ` (${c})` : "") : "rest"}`,
      }));
    }
    cols.push(h("div", { class: "hm-col" }, ...cells));
  }

  return h("div", { class: "heatmap-wrap" },
    h("div", { class: "hm-grid" }, ...cols),
    h("div", { class: "hm-legend" },
      h("i", { class: "hm-off" }), h("span", null, "Rest"),
      h("i", { class: "hm-on" }), h("span", null, "Trained")
    )
  );
}

function startOfDay(d) { d.setHours(0, 0, 0, 0); return d; }
function dayKey(d) { return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`; }
